<div #faContainer [innerHTML]="svg">

</div>